import callAPiBase from './base';

const userProfileApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/userProfileList',
      method: 'GET',
      useToken: true,
      title: 'Profile - Get',
      params,
    }),
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/userProfileListRequests',
      method: 'GET',
      useToken: true,
      title: 'Profile Request - Get',
      params,
    }),
  listAvailable: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/userProfileListAvailable',
      method: 'GET',
      useToken: true,
      title: 'Profile - list available',
      params,
    }),
  userProfileListImports: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/userProfileListImports',
      method: 'GET',
      useToken: true,
      title: 'Profile - List Imports',
      params,
    }),

  request: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileRequest',
      method: 'POST',
      useToken: true,
      title: 'Profile - Request',
      data,
    }),
  updateData: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileUpdateRequestData',
      method: 'PUT',
      useToken: true,
      title: 'Profile - Request',
      data,
    }),
  attachment: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileRequestAttachment',
      method: 'POST',
      useToken: true,
      title: 'Profile - Request Attachment',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileUpdate',
      method: 'POST',
      useToken: true,
      title: 'Profile - Update',
      data,
    }),
  updateStatus: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileUpdateStatus',
      method: 'PATCH',
      useToken: true,
      title: 'Profile - update status',
      data,
    }),
  updateRequest: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileUpdateRequest',
      method: 'POST',
      useToken: true,
      title: 'Profile - update request',
      data,
    }),
  updateExpiration: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileUpdateExpiration',
      method: 'PATCH',
      useToken: true,
      title: 'Profile - update Expiration',
      data,
    }),
  manualRelease: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/userProfileManualRelease',
      method: 'POST',
      useToken: true,
      title: 'Profile - Manual Release',
      data,
    }),
  userProfileImport: ({
    formData,
    importType,
    fileName,
    transportOperatorId,
  }: {
    formData: FormData;
    importType: string;
    fileName: string;
    transportOperatorId: string;
  }) =>
    callAPiBase({
      endpoint: `/userProfileImport?importType=${importType}&transportOperatorId=${transportOperatorId}`,
      method: 'POST',
      useToken: true,
      title: 'Profile - Import',
      formData,
    }),
};

export { userProfileApi };
export default userProfileApi;
